import DOMPurify from 'dompurify';

/* eslint-disable jsx-a11y/anchor-is-valid */
import { useScroll, useSize } from 'ahooks';
import { Ellipsis, Image, Popover, Popup, Toast } from 'antd-mobile';
import img from 'app/img';
import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import {
  AiOutlineArrowLeft,
  AiOutlineCloudDownload,
  AiOutlineShareAlt,
  AiOutlineShoppingCart,
  AiOutlineUsergroupAdd,
} from 'react-icons/ai';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserPolyInfoDT } from 'services/apis/sys/user-api';
import { UserVipDataType } from 'services/apis/usr/user-vip-api';
import { P70SndiaryMetaBO } from 'services/gather_bo/70_sndiary';
import { P80GameMetaBO } from 'services/gather_bo/80_game';
import { PostSourceType } from 'services/gather_bo/_total';
import { bizBaseUrl } from 'services/request';
import { getItemWithExpiration } from 'utils/localStorageUtil';
import { scrollTop } from 'utils/screenUtil';
import myStyles from './index.module.scss';

const ReaderArticle = () => {
  const navigate = useNavigate();
  const state = useLocation().state;
  const postTitle: string = state?.postTitle;
  const postCover: string = state?.postCover;
  const postSourceType: string = state?.postSourceType;
  const contentInfo = state?.postContentDto.contentInfo;
  const metaInfo = state?.postContentDto.metaInfo;
  const [clearHtml, setClearHtml] = useState<string>('');
  const [downloadTipHtml, setDownloadTipHtml] = useState<string>('');
  const maxUserVip: UserVipDataType = (getItemWithExpiration('userPolyInfo') as UserPolyInfoDT).vipList
    .sort((item) => item.usergroupLevel)
    .reverse()[0];

  const coverRef = useRef(null);
  const coverSize = useSize(coverRef);
  const scroll = useScroll(document);
  const isMarginTop0 = useRef(true);

  useEffect(() => {
    scrollTop();
  }, []);

  // 滚动监听
  useEffect(() => {
    const top = scroll?.top || 0;
    const width = window.innerWidth * 0.6;
    if (top <= width + 1) {
      isMarginTop0.current = true;
    } else {
      isMarginTop0.current = false;
    }
  }, [scroll]);

  interface InteractionDataProps {
    numComment: number;
    numLike: number;
    numView: number;
  }

  const InteractionData: React.FC<InteractionDataProps> = ({ numComment, numLike, numView }) => {
    return (
      <div className={[myStyles.interactionContainer, ' bg-slate-100 rounded-md shadow-md p-2'].join(' ')}>
        <div className={myStyles.interactionItem}>
          <span className={myStyles.icon}>
            💬<span className={myStyles.label}>评论数</span>
          </span>
          <span className={myStyles.text}>{numComment}</span>
        </div>
        <div className={myStyles.interactionItem}>
          <span className={myStyles.icon}>
            👍<span className={myStyles.label}>点赞数</span>
          </span>
          <span className={myStyles.text}>{numLike}</span>
        </div>
        <div className={myStyles.interactionItem}>
          <span className={myStyles.icon}>
            👁️<span className={myStyles.label}>浏览量</span>
          </span>
          <span className={myStyles.text}>{numView.toLocaleString()}</span>
        </div>
      </div>
    );
  };
  const DownloadItem: React.FC = () => {
    return (
      <div className={myStyles.downloadItem}>
        <div className={myStyles.downloadInfo}>
          <div className={myStyles.downloadRightsTitle}>
            {/* <span>甜糖大魔王 写真合集[7套][持续更新]</span> */}
            <span>{postTitle}</span>
          </div>
          <div className={myStyles.downloadCurrent}>
            <span>我的最高级别会员为：</span>
            <span>
              <span className={`${myStyles.lvIcon} ${myStyles.userGuest}`}>
                <b>{!maxUserVip ? '普通用户' : maxUserVip.usergroupName}</b>
              </span>
            </span>
            <div className=" my-2">
              <Popover.Menu
                actions={[
                  {
                    key: 'buy',
                    icon: <AiOutlineShoppingCart />,
                    text: <div className=" text-sm  text-slate-700 font-bold">赞助获取会员</div>,
                    onClick: () => {
                      Toast.show('❤ 暂不支持 ❤');
                      // navigate('/one/mine');
                    },
                  },
                  {
                    key: 'uplevel',
                    icon: <AiOutlineUsergroupAdd />,
                    text: <div className=" text-sm  text-slate-700 font-bold">推广获取会员</div>,
                    onClick: () => {
                      Toast.show('❤ 暂不支持 ❤');
                      // navigate('/one/mine');
                    },
                  },
                ]}
                placement="bottom-start"
                trigger="click"
              >
                <a className=" underline underline-offset-4">权限不足, 请先升级</a>
              </Popover.Menu>
            </div>
          </div>
          <div className={[' hidden', ' flex gap-2'].join(' ')}>
            <div className={myStyles.downloadButtonBox}>
              <button className={myStyles.button}>百度网盘</button>
            </div>
            <div className={myStyles.downloadButtonBox}>
              <button className={myStyles.button}>百度网盘</button>
            </div>
          </div>
        </div>
        <div className={[' hidden', myStyles.downloadRights].join(' ')}>
          <div className={myStyles.downloadRightsTitle}>
            <i className={`${myStyles.b2font} ${myStyles.b2DownloadCloudLine}`}></i>
            下载权限
          </div>
          <span className={myStyles.mobileShow}>查看</span>
          <ul>
            <li>
              <div>免费下载：</div>
              <div>ACGN会员</div>
              <div>福利视频会员</div>
              <div>暗网全站通</div>
            </li>
            <li>
              <div>积分下载：</div>
              <div>ACGN会员</div>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  // 净化html
  useEffect(() => {
    const _clearHtml = getSanitizeHtml(
      contentInfo?.postContentHtml
        // 替换 class，同时清理 .html 和 .php 后缀
        ?.replaceAll('class="content-excerpt"', `class="${myStyles.contentExcerpt}"`)
        ?.replaceAll(/\.html|\.php/g, '')
    );
    setClearHtml(_clearHtml);

    const _downloadTipHtml =
      DOMPurify.sanitize(`<div class="post-note"><div>    <fieldset style="        border: 1px dashed #008cff;        padding: 10px;        border-radius: 5px;        line-height: 2em;        color: #6d6d6d;      ">      <legend align="center" style="          width: 30%;          text-align: center;          background-color: #008cff;          border-radius: 5px;         background-image: linear-gradient(to right, #FFCC99, #FF99CC); text-align:center;" "="">        资源下载说明      </legend>
      <span class="btn-info btn-xs">1、</span>关于下载后有关解压、无法观看的问题，请看该文档：<a  target="_blank" rel="noopener"><span style="color: #ff007a;">解压问题和无法观看的解决方法【必看】</span></a><br>
      <span class="btn-info btn-xs">2、</span>有问题请私信管理组或到<a  target="_blank" rel="noopener"><span style="color: #ff007a;">联系客服</span></a>留言，在下方留言不回复<br>
      <span class="btn-info btn-xs">3、</span>本站资源解压密码可能不相同，请以下载页面为准<br>
      <span class="btn-info btn-xs">4、</span>本站的资源均来自于互联网，仅为资源共享、作个人学习使用，其版权均归原作者及其网站所有<br>
      <span class="btn-info btn-xs">5、</span>本站资源大多存储在云盘，如发现链接失效，请在联系客服留言我们会第一时间更新<br>
      <span class="btn-info btn-xs">6、会员充值请看：<a " target="_blank" rel="noopener"><span style="color: #ff007a;">入门教程【必看】</span></a> </span> </fieldset> </div></div>`);
    setDownloadTipHtml(_downloadTipHtml);
  }, []);

  const getSanitizeHtml = (sourceHtml: string): string => {
    // 定义一个函数来清理 HTML
    let preHtml = sourceHtml;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = preHtml;

    Toast.config({ duration: 3000 });
    Toast.config({ duration: 3000 });
    // Toast.show(PostSourceType.P70Sndiary + ":" + postSourceType);
    // 写真帖子 Sndiary 替换图片src
    if ([PostSourceType.P70Sndiary].includes(postSourceType)) {
      // Toast.show("写真帖子 Sndiary");
      // 把 data-src 的属性值赋给 src
      tempDiv.querySelectorAll('img[data-src]').forEach((img) => {
        //@ts-ignore
        img.src = img.getAttribute('data-src');
      });
      // 把 data-srcset 的属性值赋给 src
      tempDiv.querySelectorAll('img[data-srcset]').forEach((img) => {
        //@ts-ignore
        img.src = img.getAttribute('data-srcset');
      });
    }
    // 游戏帖子 Game 替换图片src
    if (
      [
        PostSourceType.P81Acggw,
        PostSourceType.P82Vikacg,
        PostSourceType.P83Acg91,
        // PostSourceType.P91Acggw,
        // PostSourceType.P92Vikacg,
        // PostSourceType.P93Acg91,
      ].includes(postSourceType)
    ) {
      // Toast.show("游戏帖子 Game");
      // 把 zoomfile 的属性值赋给 src
      tempDiv.querySelectorAll('img[zoomfile]').forEach((img) => {
        //@ts-ignore
        img.src = img.getAttribute('zoomfile');
      });
      // 移除包含 .aimg_tip 的标签
      tempDiv.querySelectorAll('.aimg_tip, .attach_nopermission, .locked').forEach((element) => element.remove());
      // 移除指定 face 的标签
      tempDiv.querySelectorAll('[face="Microsoft Yahei"]').forEach((element) => element.remove());
      // 移除第一个以外的 td 的标签
      // tempDiv.querySelectorAll("td").forEach((item, index) => {
      //   if (index !== 0) item.remove();
      // });
    }

    // 移除 script 标签
    tempDiv.querySelectorAll('script').forEach((element) => element.remove());
    // 移除空的 <strong>, <div>, <a> 元素
    tempDiv.querySelectorAll('strong, div, a').forEach((item, index) => {
      if (!item.textContent.trim()) {
        item.remove();
      }
    });
    // 移除图片宽高
    tempDiv.querySelectorAll('img').forEach((img) => {
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.removeAttribute('onmouseover');
      img.removeAttribute('onclick');
      img.removeAttribute('class');
    });
    // 移除连续换行
    tempDiv.innerHTML = tempDiv.innerHTML.replace(/(<br\s*\/?>\s*)+/gi, '<br>');

    // 返回清理后的 HTML
    preHtml = tempDiv.innerHTML;
    preHtml = preHtml
      // 移除 href 属性
      .replaceAll(/ href="[^"]*"/g, '')
      // 图片固定宽度100%
      .replaceAll(/<img /g, '<img style="width: 100%;" ')
      // 替换本地文件路径为url
      .replaceAll('\\', '/')
      .replaceAll('D:/_Resource/', bizBaseUrl + '/images/')
      // 替换链接
      .replaceAll('sndiary.com', 'uutt.com')
      .replaceAll('91acg.top', 'uutt.com');

    // 使用 DOMPurify 清理内容，去除 href 属性但保留 <a> 标签
    let clearHTML = DOMPurify.sanitize(preHtml, {
      // 允许的属性
      // ALLOWED_ATTR: ["file"], // 如果设置了, 会变成严格模式 ?
      // 移除的属性
      FORBID_ATTR: [
        'onclick',
        'onmouseover',
        'onmousedown',
        'onmouseup',
        'onmouseenter',
        'onmouseleave',
        'onmousemove',
        'onkeydown',
        'onkeyup',
        'onkeypress',
        'onsubmit',
        'onload',
        'onfocus',
        'onblur',
      ].concat([
        // sourceHtml.includes("data-srcset") && "data-src",
        // sourceHtml.includes("data-src") && "src",
        preHtml.includes('a') && 'href',
        preHtml.includes('src') && 'width',
        preHtml.includes('src') && 'width',
        // sourceHtml.includes("file") && "src",
        // sourceHtml.includes("zoomfile") && "file",
      ]),
      // 无效, 原因未知
      // hooks: {
      //   beforeSanitizeElements: (node) => {
      //     if (node.tagName === "IMG" && node.hasAttribute("data-src")) {
      //       node.setAttribute("src", node.getAttribute("zoomfile"));
      //     }
      //   },
      // },
    });

    // console.log("sourceHtml", sourceHtml);
    // return sourceHtml;

    // console.log("tempDiv", tempDiv);
    // return tempDiv;

    // console.log("preHtml", preHtml);
    // return preHtml;

    console.log('clearHTML', clearHTML);
    return clearHTML;
  };

  return (
    <>
      <div className=" ">
        {/* 返回上一页 */}
        <div className=" fixed top-0 w-full z-10">
          <div
            className={[
              ' flex w-full justify-between items-center gap-5 p-3 transition transition-100 z-10',
              isMarginTop0.current ? 'bg-black bg-opacity-50' : 'bg-orange-400 bg-opacity ',
            ].join(' ')}
            onClick={() => {
              window.history.go(-1);
            }}
          >
            <AiOutlineArrowLeft
              size={22}
              color="white"
              className=" min-w-6"
            />
            {!isMarginTop0.current && (
              <>
                <Ellipsis
                  content={postTitle}
                  className="text-center w-full h-full mt-1 text-white"
                />
              </>
            )}
          </div>
        </div>
        {/* 封面 */}
        <Image
          className=" fixed left-0 top-0"
          src={postCover}
          placeholder={
            <img
              src={img.loadingImg}
              width={window.innerWidth}
              height={window.innerWidth / 1.5}
              className=" object-cover"
            />
          }
          fallback={
            <img
              src={img.loadingImg}
              width={window.innerWidth}
              height={window.innerWidth / 1.5}
              className=" object-cover"
            />
          }
          width={window.innerWidth}
          height={window.innerWidth / 1.5}
          fit="cover"
        />
        {/* 帖子信息 */}
        <div
          className={' absolute bg-slate-50 pt-1'}
          style={{ top: window.innerWidth / 1.5 }}
        >
          {/* 元数据 */}
          <div className=" mx-2">
            {/* 帖子标题 */}
            <div className="  bg-orange-400 text-white px-2 py-3 -mx-2 -mt-7 rounded-[50px] shadow-2xl">
              <div className=" text-nowarp flex-nowarp text-center text-sm ">{postTitle}</div>
            </div>
            {/* 交互数据 */}
            {/* <div className="m-2 mt-3">
              <InteractionData
                numComment={metaInfo.numComment}
                numLike={metaInfo.numLike}
                numView={metaInfo.numView}
              />
            </div> */}
            {JSON.stringify(coverSize)}

            {/* 前往下载 */}
            <div className="text-sm flex justify-between items-center m-2 mt-3 bg-slate-200 rounded-md shadow-md px-2 py-1">
              <div className=" flex gap-3">
                <Image
                  src={img.avatar}
                  width={40}
                  height={40}
                  className=" rounded-2xl"
                />
                <div>
                  <div>UU天堂管理组</div>
                  <div>认证</div>
                </div>
              </div>
              <div
                className=" flex gap-2 border-2 rounded-md border-orange-300 text-orange-400 p-2 m-2 bg-white"
                onClick={() => {
                  document.getElementById('downloadArea').scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <AiOutlineCloudDownload size={20} />
                前往下载
              </div>
            </div>

            {/* 参演信息 */}
            {metaInfo && ('postFeat' in metaInfo || postSourceType === PostSourceType.P70Sndiary) && (
              <>
                <div className=" flex-nowrap text-nowrap whitespace-nowrap m-2 rounded-md bg-slate-100 p-1 shadow-md text-start">
                  <div className=" flex gap-3 m-1 mt-2">
                    <div>参演人物: </div>
                    <div>{(metaInfo as P70SndiaryMetaBO)?.postFeatList.join(', ') || '待补充'}</div>
                  </div>
                  <div className=" flex gap-3 m-1 mt-2">
                    <div>上传时间: </div>
                    <div>{(metaInfo as P70SndiaryMetaBO)?.postUpdateTime.toLocaleString()}</div>
                  </div>
                  <div>
                    <div className=" flex gap-3 m-1">
                      <div className=" mt-1.5">作品分类: </div>
                      <div className=" flex flex-wrap">
                        {(metaInfo as P70SndiaryMetaBO).postCateList.map((item) => (
                          <div
                            className=" flex flex-wrap"
                            key={item}
                          >
                            <div
                              className="  bg-gray-300 px-1.5 py-1 m-0.5 rounded-md shadow-sm"
                              key={item}
                            >
                              {item.includes('-') ? item.split('-')[1] : item}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {[
              PostSourceType.P81Acggw,
              PostSourceType.P82Vikacg,
              PostSourceType.P83Acg91,
              // PostSourceType.P91Acggw,
              // PostSourceType.P92Vikacg,
              // PostSourceType.P93Acg91,
            ].includes(postSourceType) && (
              <>
                <div className=" flex-nowrap text-nowrap whitespace-nowrap m-2 rounded-md bg-slate-100 p-1 shadow-md text-start">
                  <div className=" flex gap-3 m-1 mt-2">
                    <div>上传用户: </div>
                    <div>{(metaInfo as P80GameMetaBO)?.postUserName}</div>
                  </div>
                  <div className=" flex gap-3 m-1 mt-2">
                    <div>上传时间: </div>
                    <div>{(metaInfo as P80GameMetaBO)?.postUpdateTime.toLocaleString()}</div>
                  </div>
                  <div>
                    <div className=" flex gap-3 m-1">
                      <div className=" mt-1.5">作品分类: </div>
                      <div className=" flex flex-wrap">
                        {(metaInfo as P80GameMetaBO).postCateList.map((item) => (
                          <div
                            className=" flex flex-wrap"
                            key={item}
                          >
                            <div
                              className="  bg-gray-300 px-1.5 py-1 m-0.5 rounded-md shadow-sm"
                              key={item}
                            >
                              {item.includes('-') ? item.split('-')[1] : item}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className=" flex gap-3 m-1 -mt-1">
                      <div className=" mt-1.5">作品标签: </div>
                      <div className=" flex flex-wrap">
                        {(metaInfo as P80GameMetaBO).postTagList.map((item) => (
                          <div
                            className=" flex flex-wrap"
                            key={item}
                          >
                            <div
                              className="  bg-gray-300 px-1.5 py-1 m-0.5 rounded-md shadow-sm"
                              key={item}
                            >
                              {item}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* 帖子内容 */}
          <div className={[myStyles.customCss, myStyles.revertAll, ' scale-[0.95]'].join(' ')}>
            <div
              className=" m-0 p-0 bg-slate-500"
              // 使用内联样式强制应用默认样式
              style={{ all: 'revert' }}
              // 渲染 HTML 字符串
              dangerouslySetInnerHTML={{
                __html: clearHtml,
              }}
            />
          </div>

          {/* 下载按钮 */}
          <div
            className=" mx-2 my-5 px-2"
            id="downloadArea"
          >
            <h2 style={{ all: 'revert' }}>下载资源</h2>
            <div className=" bg-sky-50 p-2 rounded-md shadow-md">
              <DownloadItem />
            </div>
            {/* 下载说明 */}
            <div
              className=" bg-sky-50 p-2 rounded-md shadow-md my-5"
              dangerouslySetInnerHTML={{
                __html: downloadTipHtml,
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ReaderArticle;
